import React from 'react';

import { Card, Flex } from 'antd-v5';
import { MdAssignmentLate } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import styles from './Messages.module.scss';

function BaseMessage(props: {
  title: React.ReactNode;
  content?: React.ReactNode;
}) {
  return (
    <Card>
      <Flex gap={8} justify="center" vertical align="center">
        <MdAssignmentLate
          color={cssVars['color-text-regular']}
          className={styles.icon}
        />
        <Text font="body-body-2" strong>
          {props.title}
        </Text>
        <Text font="body-body-3">{props.content}</Text>
      </Flex>
    </Card>
  );
}

export function EmptyState() {
  return (
    <BaseMessage
      title={<FormattedMessage id="page.mbcBulkEntry.emptySelection.title" />}
      content={<FormattedMessage id="page.mbcBulkEntry.emptySelection.body" />}
    />
  );
}

export function NoAvailableYouth() {
  return (
    <BaseMessage
      title={<FormattedMessage id="page.mbcBulkEntry.noYouth.title" />}
      content={<FormattedMessage id="page.mbcBulkEntry.noYouth.body" />}
    />
  );
}
